import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../tooltip/Tooltip";
import documentedProps from "./documentation/LabeledDocumentedProps";

import("./Labeled.less");

export default class Labeled extends React.Component {
    extractLabel() {
        //Note that we call this method when we are sure that we have a string as label!
        let result = { head: "", tail: "" };

        if (this.props.label) {
            let label = this.props.label;
            let labelSplit = label.split(" ");
            let lastCharacter = labelSplit[labelSplit.length - 1];
            let magicIndex = label.lastIndexOf(lastCharacter);

            if (lastCharacter === "" || lastCharacter.length === 1) {
                magicIndex = label.lastIndexOf(labelSplit[labelSplit.length - 2]);
            }

            result.head = this.props.label.substr(0, magicIndex);
            result.tail = this.props.label.substr(magicIndex);
        }

        return result;
    }

    render() {
        let valueContainerClass = this.props.valueContainerClass;
        if (this.props.valid === false) {
            valueContainerClass += " tq-has-error";
        }
        if (this.props.hasFeedback) {
            valueContainerClass += " tq-has-feedback";
        }

        let valueWidth = this.props.valueWidth;

        //Note: When rendered in MultiInput(one label many input components) form elements,
        //are expected to render only their value container. This comes from design team.
        //Value container cannot live without their wrapper in any other case, do NOT use
        //isInMultiInput property in other cases!
        if (this.props.isInMultiInput) {
            if (this.props.extraClasses) {
                valueContainerClass += ` ${this.props.extraClasses}`;
            }
            if (valueWidth) {
                valueWidth += "%";
            }
            return (
                <div className={valueContainerClass} style={{ width: valueWidth }}>
                    {this.props.children}
                </div>
            );
        }

        let containerClass = this.props.containerClass;
        containerClass += this.props.vertical ? " tq-vertical" : "";
        containerClass += this.props.animated ? " tq-animated" : "";
        containerClass += this.props.disabled ? " tq-disabled" : "";
        containerClass += this.props.valid === false ? " tq-has-error" : "";
        containerClass += this.props.unitsDisabled ? " tq-disabled-units" : ""; //Input Number
        //containerClass += this.props.label || this.props.label === "" ? "" : " tq-no-label";
        let labelExist = this.props.label || this.props.label === "";
        if (!labelExist) {
            containerClass += this.props.iconLabel ? "" : " tq-no-label";
        }

        let labelClass = "tq-label-container";
        labelClass += this.props.labelAlignment ? " tq-label-" + this.props.labelAlignment : "";

        let iconToShow;
        if (this.props.required) {
            iconToShow = <span className="tq-required" />;
        }
        if (this.props.showValidityIcon && this.props.valid) {
            iconToShow = <span className="tq-validated" />;
        }

        let tooltipIcon, labelButton;
        if (this.props.labelButton) {
            labelButton = (
                <div className="tq-feedback-container">
                    <div className="tq-input-feedback">
                        <i
                            className={"tq-feedback-icon " + this.props.labelButton}
                            onClick={this.props.onClickLabelButton}
                        />
                    </div>
                </div>
            );
        }
        if (this.props.hint) {
            let tooltipMaxWidth;
            let tooltipContainerClasses = this.props.tooltipContainerClasses;
            if (this.props.tooltipMaxWidth) {
                tooltipMaxWidth = this.props.tooltipMaxWidth + "px";
            }
            tooltipIcon = (
                <Tooltip
                    placeholderClass={tooltipContainerClasses}
                    value={this.props.hint}
                    maxWidth={tooltipMaxWidth}
                >
                    <div className="tq-feedback-container">
                        <div className="tq-input-feedback">
                            <i className="tq-feedback-icon tq-icon-circle-info" />
                        </div>
                    </div>
                </Tooltip>
            );
        }

        let labelWidth = this.props.labelWidth;
        if (!labelWidth && valueWidth) {
            labelWidth = 100 - valueWidth;
        }
        if (!valueWidth && labelWidth) {
            valueWidth = 100 - labelWidth;
        }
        if (labelWidth || valueWidth) {
            labelWidth += "%";
            valueWidth += "%";
        }

        //TODO good idea that does not work properly!
        // if (!this.props.label && this.props.label !== "") {
        //     //In case we are with skip label we don't want to render the label markup.
        //     //This is done for simple markup and for Paragraph container case.
        //     let filteredChildren = [];
        //     React.Children.forEach(this.props.children, (child) => {
        //         if (React.isValidElement(child)) {
        //             filteredChildren.push(child);
        //         }
        //     });
        //     return filteredChildren;
        // }

        return (
            <div className={containerClass} data-tq-id={this.props.dataTqId}>
                {this.props.iconLabel && (
                    <div className={labelClass} style={{ width: labelWidth }}>
                        <label className="tq-label">
                            <i className={this.props.iconLabel} />
                        </label>
                    </div>
                )}
                {labelExist && (
                    <div className={labelClass} style={{ width: labelWidth }}>
                        <label className="tq-label">
                            <span className="tq-text-node">
                                {this.extractLabel().head}
                                <span className="tq-hint-container">
                                    <span className="tq-text-node">{this.extractLabel().tail}</span>
                                    {iconToShow}
                                    {tooltipIcon}
                                    {labelButton}
                                </span>
                            </span>
                        </label>
                    </div>
                )}
                <div className={valueContainerClass} style={{ width: valueWidth }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

Labeled.documentedProps = documentedProps;

Labeled.propTypes = {
    isInMultiInput: PropTypes.bool,
    containerClass: PropTypes.string, //not documented technical property!
    valueContainerClass: PropTypes.string, //not documented technical property!
    disabled: PropTypes.bool,
    vertical: PropTypes.bool,
    hasFeedback: PropTypes.bool, //not documented technical property!
    hint: PropTypes.string, //hint here is always considered discrete!
    discreteHint: PropTypes.bool,
    label: PropTypes.string,
    labelButton: PropTypes.string,
    onClickLabelButton: PropTypes.func,
    skipLabel: PropTypes.bool,
    valueWidth: PropTypes.number,
    labelWidth: PropTypes.number,
    onLabelClick: PropTypes.func, //not documented technical property!
    tooltipMaxWidth: PropTypes.number,
    tooltipContainerClasses: PropTypes.string,
    dataTqId: PropTypes.string,
    labelAlignment: PropTypes.oneOf(["left", "center", "right"]),
    iconLabel: PropTypes.string
};

Labeled.displayName = "Labeled";
